export const imagePath = () => {
    return `${process.env.REACT_APP_BASE_URL}/`;
};

/** Full URL of an uploaded image / video path (already-absolute URLs are returned as they are). */
export const getImageUrl = (imgPath) => {
    if (!imgPath) return '';
    if (imgPath.startsWith('http://') || imgPath.startsWith('https://')) {
        return imgPath;
    }
    return `${imagePath()}${imgPath}`;
};

/** URL to display for an activity media item: a video's thumbnail when it has one, otherwise its url. */
export const getThumbnailUrl = (mediaItem) => {
    if (!mediaItem) return '';
    if (mediaItem.type && mediaItem.type.startsWith('video/') && mediaItem.thumbnail) {
        return getImageUrl(mediaItem.thumbnail);
    }
    return mediaItem.url ? getImageUrl(mediaItem.url) : '';
};

/** Full URL of a user's / organization's first profile photo, or '' when there is none. */
export const profilePhotoUrl = (user) => {
    const filePath = Array.isArray(user?.imageURL) ? user.imageURL[0]?.filePath : "";
    if (!filePath) return "";
    if (/^https?:\/\//.test(filePath)) return filePath;
    return `${imagePath()}${filePath.replace(/^\/+/, "")}`;
};
